import {
    Pack,
    HeroBannerEntityType,
    HeroBannerContentType,
} from 'types/generated/graphql';
import { BaseMeta } from 'types';
import { Maybe } from 'graphql/jsutils/Maybe';

export enum SlideTypes {
    Labels = 'labels',
    Packs = 'packs',
    Repacks = 'repacks',
}

export type LabelPacks = [Pack | undefined, Pack | undefined, Pack | undefined];

export type SlideArtwork = {
    isExclusive?: boolean;
    artworkUrl: string;
};

export type SlideArtworks = [SlideArtwork, SlideArtwork, SlideArtwork];

// We got Maybe because it's from Apollo
export interface SlideProps {
    byline?: Maybe<string>;
    contentType?: HeroBannerContentType;
    description?: Maybe<string>;
    entity?: HeroBannerEntityType;
    title?: Maybe<string>;
    guid?: string;
    tags?: BaseMeta[];
    isLoading?: boolean;
    labelPacks?: Maybe<Maybe<Pack>[]>;
}

export type SlideDetails = {
    tags?: BaseMeta[];
    type?: SlideTypes;
    demoGuid?: string;
    byline?: string;
    title?: string;
    description?: string;
    slug?: string;
    playDemoCallback?: (totalTime: number) => void;
};

export type Artwork = {
    isExclusive: boolean;
    artworkUrl: string;
};

export interface SlideWithFallbackProps {
    isVertical: boolean;
    isLoading: boolean;
    artworks?: [Artwork, Artwork, Artwork];
    backgroundColor?: string;
    foregroundColor?: string;
    details?: SlideDetails;
}

export type DetailsProps = { isLoading: boolean; details?: SlideDetails };
